module.exports = __webpack_public_path__ + "static/media/dislike_click.d6ae7601.svg";